import React from "react";
import { CheckboxCircle } from "./styles";
import CheckCircleIcon from "../../../assets/Check_Circle.png";

interface Props {
  selected: boolean;
}

function CheckCircle({ selected }: Props): JSX.Element {
  return (
    <CheckboxCircle checked={selected} role="button">
      <img src={CheckCircleIcon} alt="league check circle" loading="lazy" />
    </CheckboxCircle>
  );
}

export default CheckCircle;
